module.exports = __webpack_public_path__ + "img/Group 3@2x1.56bef551.png";